import React, { useState } from "react";
import { DateTimeDisplay, Breadcrumbs } from "../../components/ui";
import { useBreadcrumbs } from '../../hooks/useBreadcrumbs';

export const Help: React.FC = () => {
    const breadcrumbs = useBreadcrumbs({
        currentPageTitle: 'Help',
    });
  return (
    <main>
            <div className="container mb-2">
                <section className='page'>
                    <h2 className="heading__title heading__title--help">Help</h2>
                    <DateTimeDisplay />
                </section>
                <Breadcrumbs items={breadcrumbs} />

                <div className="alarm-content pb-1">
                    <h3 className="heading__title heading__title--help">Coming Soon!</h3>
                    <p className="mt-2">The help page is under construction and will be available soon.</p>
                </div>
            </div>  
    </main>
  );
}       
export default Help;